import { Modal, Box, IconButton } from "@mui/material";
import { useState } from "react";
import CloseIcon from "@mui/icons-material/Close";
import IosShareIcon from "@mui/icons-material/IosShare";

const PdfViewModal = ({ pdfUrl, setIsPdfView, setPdfUrl }) => {
  const [open, setOpen] = useState(true);
  const handleClose = () => {
    setOpen(false);
    setIsPdfView(false);
    setPdfUrl("");
  };
  return (
    <>
      <div
        style={{
          height: "100%",
          width: "100%",
        }}
      >
        <Modal open={open} onClose={handleClose}>
          <Box
            sx={{
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              // height: 800,
              // width:  1200,
              width: "70%", // 80% of the viewport width
              height: "90%", // 60% of the viewport height
              bgcolor: "background.paper",
              boxShadow: 24,
              p: 4,
            }}
          >
            <div style={{ position: "absolute", top: "10px", right: "10px" }}>
              <IconButton
                style={{
                  position: "absolute", // Example position
                  top: "-10px",
                  right: "-10px",
                  color: "blue", // Set color
                  // backgroundColor: "rgba(60, 89, 192, 0.5)", // Background with opacity
                  borderRadius: "50%", // Ensure circular button
                  padding: "8px", // Add padding for size
                }}
                onClick={handleClose}
              >
                <CloseIcon />
              </IconButton>
            </div>
            <div style={{ position: "absolute", top: "10px", right: "10px" }}>
              <IconButton
                style={{
                  position: "absolute", // Example position
                  top: "-22px",
                  right: "30px",
                  color: "blue", // Set color
                  // backgroundColor: "rgba(60, 89, 192, 0.5)", // Background with opacity
                  borderRadius: "50%", // Ensure circular button
                  padding: "8px", // Add padding for size
                }}
                // onClick={handleClose}
              >
                <a href={pdfUrl} target="_blank" rel="noreferrer">
                  <IosShareIcon />
                </a>
              </IconButton>
            </div>
            {pdfUrl ? (
              <iframe
                src={pdfUrl}
                width="100%"
                height="100%"
                title="pdf-viewer"
              >
                This browser does not support embedded PDFs.
              </iframe>
            ) : (
              <div>No Url Found</div>
            )}
          </Box>
        </Modal>
      </div>
    </>
  );
};

export default PdfViewModal;
